<template>
  <hic-list-page title="病历元素" :entities="entities" :condition="condition" @load="page" :loading="searchLoading" keyword-placeholder="请输入名称">
    <template slot="buttons">
      <el-button type="primary" @click="create" size="small" v-if="permission.emr_ele_query"> <i class="el-icon-plus"></i> 新建 </el-button>
    </template>

    <el-table-column label="操作" fixed="left" width="120" align="center">
      <template slot-scope="scope">
        <el-button v-if="permission.emr_ele_edit && scope.row.id" type="primary" icon="el-icon-edit" circle plain size="mini" @click="edit(scope.row, scope.$index)" title="编辑" />
        <el-popconfirm v-if="permission.emr_ele_delete" title="确定要删除吗?" icon-color="red" @confirm="del(scope.row)" class="left-pad">
          <el-button slot="reference" title="删除" type="danger" plain size="mini" circle icon="el-icon-delete"></el-button>
        </el-popconfirm>
        <el-button v-if="permission.emr_ele_edit && scope.row.id" type="primary" icon="el-icon-document-copy" circle plain size="mini" @click="copy(scope.row)" title="复制" class="left-pad" />
      </template>
    </el-table-column>
    <el-table-column label="名称" prop="name" sortable="custom" fixed="left" show-overflow-tooltip>
      <template slot-scope="{ row }">
        <b>{{ row.name }}</b>
      </template>
    </el-table-column>
    <el-table-column label="标签" sortable="custom" prop="label" width="100"></el-table-column>
    <el-table-column label="类型" sortable="custom" align="center" prop="type" width="120" :filters="dictEnum.MrElementType" :filter-multiple="false" column-key="type">
      <template slot-scope="{ row }">
        {{ row.type | dictText("MrElementType") }}
      </template>
    </el-table-column>
    <el-table-column label="标签输出" prop="ifExportLabel" width="80" align="center">
      <template slot-scope="{ row }">
        <el-tag v-if="row.ifExportLabel" type="primary" hit size="mini">是</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="标签换行" prop="ifBreakAfterLabel" width="80" align="center">
      <template slot-scope="{ row }">
        <el-tag v-if="row.ifBreakAfterLabel" type="primary" hit size="mini">是</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="只读" prop="EditProtect" width="80" align="center">
      <template slot-scope="{ row }">
        <el-tag v-if="row.EditProtect" type="primary" hit size="mini">是</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="必填" prop="MustFillContent" width="80" align="center">
      <template slot-scope="{ row }">
        <el-tag v-if="row.MustFillContent" type="primary" hit size="mini">是</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="隐藏" prop="IsCtrlHidden" width="80" align="center">
      <template slot-scope="{ row }">
        <el-tag v-if="row.IsCtrlHidden" type="primary" hit size="mini">是</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="默认值" prop="defaultValue" align="center">
      <template slot-scope="{ row }">
        <span v-if="row.dictType">{{ row.defaultValue | dictText(row.dictType) }}</span>
        <span v-else>{{ row.defaultValue }}</span>
      </template>
    </el-table-column>
    <edit :visible.sync="showEdit" v-model="entity" @saved="saved" />
  </hic-list-page>
</template>

<script>
  import { mapGetters } from "sw-hic";
  import store from "@/common/store";
  export default {
    beforeRouteEnter(to, from, next) {
      // 在渲染该组件的对应路由被 confirm 前调用
      // 不！能！获取组件实例 `this`
      // 因为当守卫执行前，组件实例还没被创建
      if (!store.getters.permission.emr_ele_query) {
        next({
          name: "err",
          params: { err: cfg.errs.NeedPromission },
        });
      } else {
        next();
      }
    },
    beforeRouteLeave(to, from, next) {
      // 导航离开该组件的对应路由时调用
      // 可以访问组件实例 `this`
      this.showEdit = false;
      next();
    },
    components: {
      edit: () => import("./edit"),
    },
    data() {
      return {
        searchLoading: false,
        showEdit: false,
        entities: {},
        entity: {},
        defaultData: {
          DeleteProtect: true,
          EditProtect: false,
          IsCtrlHidden: false,
          Printable: true,
          MustFillContent: false,
          ViewSecret: false,
          IsNotRecordInXML: true,
        },
        condition: {
          keyword: null,
          pageIndexOnView: 1,
          pageSize: 20,
        },
        editIndex: null,
      };
    },

    computed: {
      ...mapGetters(["dict", "dictEnum", "permission"]),
    },
    methods: {
      page() {
        let _this = this;
        this.searchLoading = true;
        this.$api.Element.query(this.condition)
          .then((res) => {
            _this.entities = res;
          })
          .finally(() => {
            _this.searchLoading = false;
          });
      },
      create() {
        this.entity = Object.assign({}, this.defaultData);
        this.showEdit = true;
      },
      edit(row) {
        this.entity = this.$utils.Obj.clone(row);
        this.showEdit = true;
      },
      copy(row) {
        this.entity = this.$utils.Obj.clone(row);
        this.entity.id = null
        this.entity.name = null
        this.showEdit = true;
      },
      del(row) {
        this.$api.Element.del(row.id).then(
          (res) => {
            this.page();
          },
          (msg) => {
            this.$message({
              type: "error",
              message: msg,
            });
          }
        );
      },
      saved() {
        this.page();
      },
      filterChanged(options) {
        Object.assign(this.condition, options);
        this.page();
      },
      sortChanged(col) {
        if (!col.order) {
          this.condition.sort = "id";
          this.condition.asc = false;
        } else {
          this.condition.sort = col.prop;
          this.condition.asc = col.order == "ascending";
        }
        this.page();
      },
    },
  };
</script>

<style scoped></style>
